import React, { useEffect, useState, useRef } from "react";
import "./Sidebar.css";
import { Container } from "react-bootstrap";
import { NavLink } from "react-router-dom";
import apiCall from "../API/API";
import "bootstrap/dist/css/bootstrap.min.css";
import { AiFillHome } from "react-icons/ai";
import { IoIosPeople } from "react-icons/io";
import { BsFillCartCheckFill } from "react-icons/bs";
import { MdCreditScore, MdToken } from "react-icons/md";
import { RiFolderTransferLine } from "react-icons/ri";
import { IoIosLogOut } from "react-icons/io";
import { RiFundsBoxFill } from "react-icons/ri";
import { RiFundsLine } from "react-icons/ri";
import { AiTwotoneFund } from "react-icons/ai";
import { RiRefund2Line } from "react-icons/ri";
import { SiHiveBlockchain } from "react-icons/si";
import { AiOutlineFundProjectionScreen } from "react-icons/ai";
import { RiExchangeFundsLine } from "react-icons/ri";
import { BiTransferAlt } from "react-icons/bi";
import { BsChevronDown } from "react-icons/bs";
import { IoIosPersonAdd } from "react-icons/io";
import { BiPackage } from "react-icons/bi";
import { IoMdWallet } from "react-icons/io";
import { RiTeamLine } from "react-icons/ri";
import { PiHandDepositFill } from "react-icons/pi";
import { RxLoop } from "react-icons/rx";
import { RiUserSettingsFill } from "react-icons/ri";
import { GiLetterBomb } from "react-icons/gi";
import { SiBnbchain } from "react-icons/si";
import { GiHamburgerMenu } from "react-icons/gi";
import { IoMdSettings } from "react-icons/io";
import { FaMoneyBillAlt, FaMoneyCheckAlt, FaPoll } from "react-icons/fa";
import NavPages from "../NavPages";
import { useNavigate } from "react-router-dom";
import { BsHddStackFill } from "react-icons/bs";
import Change from "../Common/StringToSub";
import useWindowDimensions from "../Common/useWindowDimensions";
import { useSelector, useDispatch } from "react-redux";
import { Data } from "../Common/Data";
import { IoQrCodeSharp } from "react-icons/io5";
import { BsBank2 } from "react-icons/bs";
import { IoNewspaperOutline } from "react-icons/io5";
import { GiReceiveMoney } from "react-icons/gi";
import { FaGifts } from "react-icons/fa6";
import { MdVerified } from "react-icons/md";
import { MyDelay } from "../Common/Data";
import { BiMoneyWithdraw } from "react-icons/bi";
import { GiTakeMyMoney } from "react-icons/gi";
import { TbReportMoney } from "react-icons/tb";
import { fetchDashboardData } from "../Actions/adminActions";
import { IoCopy } from "react-icons/io5";
import CopyFromtag from "../Common/CopyFromtag";
import ConnectButton from "../Component/ConnectButton";
import { logout } from "../Actions/adminActions";
import { RiUserSharedLine } from "react-icons/ri";
import { MdOutlineSupportAgent } from "react-icons/md";
import { FaMoneyCheck } from "react-icons/fa6";
import { CiMoneyBill } from "react-icons/ci";
import { PiHandWithdrawFill } from "react-icons/pi";
import { MdKey } from "react-icons/md";
import { MdAssuredWorkload } from "react-icons/md";
import { RiTeamFill } from "react-icons/ri";
import { toast } from "react-toastify";
import RewardControls from "../Pages/Rewards/RewardControls";

const Sidebar = () => {
  const { loading, error, user } = useSelector((state) => state.admin);
  const navigate = useNavigate();
  useEffect(() => {
    if (error?.code === 419) {
      navigate("/");
    }
  }, [error]);
  // const acc = useSelector((state) => state.account.value);

  const userAddress = localStorage.getItem("userAddress");
  const [openDropdown, setOpenDropdown] = useState(null);

  const { height, width } = useWindowDimensions();
  const hasFetchedData = useRef(false);
  const [toggle, setToggle] = useState("0");

  async function Logout() {
    try {
      await MyDelay(500);

      const response = await apiCall("POST", "/logout");
      console.log("Logout response:", response);
      // if(response?.data?.success){
      //   dispatch(logout());
      //   navigate("/", { replace: true });
      // }else {
      //   toast.error("Logout failed. Please try again.");
      // }
    } catch (error) {
      console.error("Logout error:", error);
    } finally {
      dispatch(logout());
      navigate("/", { replace: true });
    }
  }

  useEffect(() => {
    if (error?.code === 419) {
      navigate("/", { replace: true });
    }
  }, [error, navigate]);

  useEffect(() => {
    if (width < 900) {
      setToggle("-260px");
    }
  }, [width]);

  const dispatch = useDispatch();
  const { dashboardData } = useSelector((state) => state.admin);
  useEffect(() => {
    if (!hasFetchedData.current) {
      dispatch(fetchDashboardData());
      hasFetchedData.current = true;
    }
  }, []);
  const handleDropdownToggle = (dropdownName) => {
    setOpenDropdown((prevState) =>
      prevState === dropdownName ? null : dropdownName
    );
  };

  return (
    <React.Fragment>
      <Container fluid className="p-0">
        <div id="sidebar-wrapper" className="" style={{ left: toggle }}>
          <div id="sidebarTopDiv">
            <div className="logo">
              <img
                src={Data.logoIc}
                alt="logo.png"
                height="auto"
                width="100px"
              />
            </div>
          </div>
          <section style={{ padding: "5px", marginTop: "80px" }}>
            <div className="logowithtext">
              {/* <img src={Data.logo} alt="logo.png" /> */}
              <h3 className="m-0">
                User Name <div></div>
              </h3>
              <p>{Change(userAddress)} </p>
            </div>
            <NavLink
              to=""
              end
              activeClassName="active"
              onClick={() => (width < 800 ? setToggle("-260px") : "")}
            >
              <div className="items">
                <i>
                  <AiFillHome />
                </i>
                <h4 className="m-0">Dashboard</h4>
              </div>
            </NavLink>
            <div
              className="dropdownitems"
              onClick={() => handleDropdownToggle("users")}
            >
              <div className={`head items`}>
                <i>
                  <IoIosPeople />
                </i>
                <h4 className="m-0">Users</h4>
                <i
                  className="dropicon"
                  style={{
                    transform: `rotate(${
                      openDropdown === "users" ? "180deg" : "0deg"
                    })`,
                  }}
                >
                  <BsChevronDown />
                </i>
              </div>
              {openDropdown === "users" && (
                <div className="dropdown">
                  <NavLink
                    to="all_users"
                    activeClassName="active"
                    onClick={(e) => {
                      e.stopPropagation();
                      if (width < 800) {
                        setToggle("-260px");
                      }
                    }}
                  >
                    <div className="items">
                      <i>
                        <GiLetterBomb />
                      </i>
                      <h4 className="m-0">All Users</h4>
                    </div>
                  </NavLink>

                  <NavLink
                    to="rank"
                    activeClassName="active"
                    onClick={(e) => {
                      e.stopPropagation();
                      if (width < 800) {
                        setToggle("-260px");
                      }
                    }}
                  >
                    <div className="items">
                      <i>
                        <FaGifts />
                      </i>
                      <h4 className="m-0">Ranks</h4>
                    </div>
                  </NavLink>
                </div>
              )}
            </div>

            {/* <div
              className="dropdownitems"
              onClick={() => handleDropdownToggle("funds")}
            >
              <div className={`head items`}>
                <i>
                  <AiOutlineFundProjectionScreen />
                </i>
                <h4 className="m-0">Funds</h4>
                <i
                  className="dropicon"
                  style={{
                    transform: `rotate(${
                      openDropdown === "funds" ? "180deg" : "0deg"
                    })`,
                  }}
                >
                  <BsChevronDown />
                </i>
              </div>
              {openDropdown === "funds" && (
                <div className="dropdown">
                  <NavLink
                    to="add_fund"
                    activeClassName="active"
                    onClick={(e) => {
                      e.stopPropagation();
                      if (width < 800) {
                        setToggle("-260px");
                      }
                    }}
                  >
                    <div className="items">
                      <i>
                        <RiRefund2Line />
                      </i>
                      <h4 className="m-0">Add Funds</h4>
                    </div>
                  </NavLink>
                  <NavLink
                    to="add_fund_history"
                    activeClassName="active"
                    onClick={(e) => {
                      e.stopPropagation();
                      if (width < 800) {
                        setToggle("-260px");
                      }
                    }}
                  >
                    <div className="items">
                      <i>
                        <RiFundsLine />
                      </i>
                      <h4 className="m-0">Add Funds History</h4>
                    </div>
                  </NavLink>
                  {/* <NavLink
                    to="retrieve_fund"
                    activeClassName="active"
                    onClick={(e) => {
                      e.stopPropagation();
                      if (width < 800) {
                        setToggle("-260px");
                      }
                    }}
                  >
                    <div className="items">
                      <i>
                        <RiExchangeFundsLine />
                      </i>
                      <h4 className="m-0">Retrieve Fund </h4>
                    </div>
                  </NavLink>
                  <NavLink
                    to="retrieve_fund_history"
                    activeClassName="active"
                    onClick={(e) => {
                      e.stopPropagation();
                      if (width < 800) {
                        setToggle("-260px");
                      }
                    }}
                  >
                    <div className="items">
                      <i>
                        <TbReportMoney />
                      </i>
                      <h4 className="m-0">Retrieve Fund History</h4>
                    </div>
                  </NavLink>
                  <NavLink
                    to="fund_history"
                    activeClassName="active"
                    onClick={(e) => {
                      e.stopPropagation();
                      if (width < 800) {
                        setToggle("-260px");
                      }
                    }}
                  >
                    <div className="items">
                      <i>
                        <GiLetterBomb />
                      </i>
                      <h4 className="m-0">Funds History</h4>
                    </div>
                  </NavLink>
                  <NavLink
                    to="fund_transfer_history"
                    activeClassName="active"
                    onClick={(e) => {
                      e.stopPropagation();
                      if (width < 800) {
                        setToggle("-260px");
                      }
                    }}
                  >
                    <div className="items">
                      <i>
                        <BiTransferAlt />
                      </i>
                      <h4 className="m-0">Funds Transfer History</h4>
                    </div>
                  </NavLink> */}
            {/*</div>
              )}
            </div> */}

            {/* <NavLink
              to="rewards"
              activeClassName="active"
              onClick={(e) => {
                e.stopPropagation();
                if (width < 800) {
                  setToggle("-260px");
                }
              }}
            >
              <div className="items">
                <i>
                  <BiMoneyWithdraw />
                </i>
                <h4 className="m-0">Rewards</h4>
                <div
                  className="reminder"
                  style={{
                    backgroundColor:
                      dashboardData?.pendingPointWithdrawals === 0
                        ? "green"
                        : "red",
                  }}
                >
                  {dashboardData?.pendingPointWithdrawals}
                </div>
              </div>
            </NavLink> */}

            {/* <NavLink
              to="withdraw_controls"
              activeClassName="active"
              onClick={(e) => {
                e.stopPropagation();
                if (width < 800) {
                  setToggle("-260px");
                }
              }}
            >
              <div className="items">
                <i>
                  <BiMoneyWithdraw />
                </i>
                <h4 className="m-0">Withdrawal</h4>
                <div
                  className="reminder"
                  style={{
                    backgroundColor:
                      dashboardData?.pendingPointWithdrawals === 0
                        ? "green"
                        : "red",
                  }}
                >
                  {dashboardData?.pendingPointWithdrawals}
                </div>
              </div>
            </NavLink> */}

            {/* <NavLink
              to="principal_withdrawal"
              activeClassName="active"
              onClick={(e) => {
                e.stopPropagation();
                if (width < 800) {
                  setToggle("-260px");
                }
              }}
            >
              <div className="items">
                <i>
                  <PiHandWithdrawFill />
                </i>
                <h4 className="m-0">Principle Withdrawal</h4>
                <div
                  className="reminder"
                  style={{
                    backgroundColor:
                      dashboardData?.countPendingPrincipalWithdrawals === 0
                        ? "green"
                        : "red",
                  }}
                >
                  {dashboardData?.countPendingPrincipalWithdrawals}
                </div>
              </div>
            </NavLink>  */}

            {/* <NavLink
              to="token_withdraw_controls"
              activeClassName="active"
              onClick={(e) => {
                e.stopPropagation();
                if (width < 800) {
                  setToggle("-260px");
                }
              }}
            >
              <div className="items">
                <i>
                  <MdToken />
                </i>
                <h4 className="m-0">Token Withdrawal</h4>
                <div
                  className="reminder"
                  style={{
                    backgroundColor:
                      dashboardData?.countTokenPendingWithdrawals === 0
                        ? "green"
                        : "red",
                  }}
                >
                  {dashboardData?.countTokenPendingWithdrawals}
                </div>
              </div>
            </NavLink> */}

            <NavLink
              to="payout_controls"
              activeClassName="active"
              onClick={() => (width < 800 ? setToggle("-260px") : "")}
            >
              <div className="items">
                <i>
                  <FaMoneyCheckAlt />
                </i>
                <h4 className="m-0">Payout Report</h4>
              </div>
            </NavLink>

            {/* <NavLink
              to="release_income_controls"
              activeClassName="active"
              onClick={() => (width < 800 ? setToggle("-260px") : "")}
            >
              <div className="items">
                <i>
                  <FaMoneyCheck />
                </i>
                <h4 className="m-0">Release Income</h4>
              </div>
            </NavLink> */}

            <NavLink
              to="orders"
              activeClassName="active"
              onClick={() => (width < 800 ? setToggle("-260px") : "")}
            >
              <div className="items">
                <i>
                  <BsFillCartCheckFill />
                </i>
                <h4 className="m-0">Order History</h4>
              </div>
            </NavLink>

            <NavLink
              to="token_settings"
              activeClassName="active"
              onClick={() => (width < 800 ? setToggle("-260px") : "")}
            >
              <div className="items">
                <i>
                  <MdToken />
                </i>
                <h4 className="m-0">Token Settings</h4>
              </div>
            </NavLink>

            <NavLink
              to="onchain_token_rate"
              activeClassName="active"
              onClick={() => (width < 800 ? setToggle("-260px") : "")}
            >
              <div className="items">
                <i>
                  <SiBnbchain />
                </i>
                <h4 className="m-0">Token rate</h4>
              </div>
            </NavLink>

            <NavLink
              to="onchain_stake_token_percent"
              activeClassName="active"
              onClick={() => (width < 800 ? setToggle("-260px") : "")}
            >
              <div className="items">
                <i>
                  <SiBnbchain />
                </i>
                <h4 className="m-0">Stake token %</h4>
              </div>
            </NavLink>

            {/* <div
              className="dropdownitems"
              onClick={() => handleDropdownToggle("dummyData")}
            >
              <div className={`head items`}>
                <i>
                  <RiUserSettingsFill />
                </i>
                <h4 className="m-0">Dummy Data</h4>
                <i
                  className="dropicon"
                  style={{
                    transform: `rotate(${
                      openDropdown === "dummyData" ? "180deg" : "0deg"
                    })`,
                  }}
                >
                  <BsChevronDown />
                </i>
              </div>
              {openDropdown === "dummyData" && (
                <div className="dropdown">
                  <NavLink
                    to="register_user"
                    activeClassName="active"
                    onClick={(e) => {
                      e.stopPropagation();
                      if (width < 800) setToggle("-260px");
                    }}
                  >
                    <div className="items">
                      <i>
                        <IoIosPersonAdd />
                      </i>
                      <h4 className="m-0">Register Dummy User</h4>
                    </div>
                  </NavLink>
                  <NavLink
                    to="dummy_user_wallets"
                    activeClassName="active"
                    onClick={(e) => {
                      e.stopPropagation();
                      if (width < 800) setToggle("-260px");
                    }}
                  >
                    <div className="items">
                      <i>
                        <IoMdWallet />
                      </i>
                      <h4 className="m-0">Dummy User Wallets</h4>
                    </div>
                  </NavLink>
                  <NavLink
                    to="dummy_team_update"
                    activeClassName="active"
                    onClick={(e) => {
                      e.stopPropagation();
                      if (width < 800) setToggle("-260px");
                    }}
                  >
                    <div className="items">
                      <i>
                        <RiTeamLine />
                      </i>
                      <h4 className="m-0">Dummy User Team</h4>
                    </div>
                  </NavLink>
                  <NavLink
                    to="buy_order"
                    activeClassName="active"
                    onClick={(e) => {
                      e.stopPropagation();
                      if (width < 800) setToggle("-260px");
                    }}
                  >
                    <div className="items">
                      <i>
                        <BiPackage />
                      </i>
                      <h4 className="m-0">Add Fake Order</h4>
                    </div>
                  </NavLink>
                  <NavLink
                    to="place_withdrawal"
                    activeClassName="active"
                    onClick={(e) => {
                      e.stopPropagation();
                      if (width < 800) setToggle("-260px");
                    }}
                  >
                    <div className="items">
                      <i>
                        <PiHandDepositFill />
                      </i>
                      <h4 className="m-0">Add Fake Withdrawal</h4>
                    </div>
                  </NavLink>
                  <NavLink
                    to="automate_entries"
                    activeClassName="active"
                    onClick={(e) => {
                      e.stopPropagation();
                      if (width < 800) setToggle("-260px");
                    }}
                  >
                    <div className="items">
                      <i>
                        <RxLoop />
                      </i>
                      <h4 className="m-0">Automate Dummy Entries</h4>
                    </div>
                  </NavLink>
                </div>
              )}
            </div> */}

            {/* <NavLink
              to="news"
              activeClassName="active"
              onClick={(e) => {
                e.stopPropagation();
                if (width < 800) {
                  setToggle("-260px");
                }
              }}
            >
              <div className="items">
                <i>
                  <IoNewspaperOutline />
                </i>
                <h4 className="m-0">News</h4>
              </div>
            </NavLink> */}

            {/*<div
              className="dropdownitems"
              onClick={() => handleDropdownToggle("gamePoints")}
            >
              <div className={`head items`}>
                <i>
                  <FaGifts />
                </i>
                <h4 className="m-0">Game Points</h4>
                <i
                  className="dropicon"
                  style={{
                    transform: `rotate(${
                      openDropdown === "gamePoints" ? "180deg" : "0deg"
                    })`,
                  }}
                >
                  <BsChevronDown />
                </i>
              </div>
              {openDropdown === "gamePoints" && (
                <div className="dropdown">
                  <NavLink
                    to="tap_tap_game_settings"
                    activeClassName="active"
                    onClick={(e) => {
                      e.stopPropagation();
                      if (width < 800) {
                        setToggle("-260px");
                      }
                    }}
                  >
                    <div className="items">
                      <i>
                        <MdToken />
                      </i>
                      <h4 className="m-0">Tap Tap Game Settings</h4>
                    </div>
                  </NavLink>
                  <NavLink
                    to="spin_game_settings"
                    activeClassName="active"
                    onClick={(e) => {
                      e.stopPropagation();
                      if (width < 800) {
                        setToggle("-260px");
                      }
                    }}
                  >
                    <div className="items">
                      <i>
                        <MdToken />
                      </i>
                      <h4 className="m-0">Spin Game Settings</h4>
                    </div>
                  </NavLink>
                  <NavLink
                    to="daily_claim_settings"
                    activeClassName="active"
                    onClick={(e) => {
                      e.stopPropagation();
                      if (width < 800) {
                        setToggle("-260px");
                      }
                    }}
                  >
                    <div className="items">
                      <i>
                        <MdToken />
                      </i>
                      <h4 className="m-0">Daily Claim Settings</h4>
                    </div>
                  </NavLink>
                  <NavLink
                    to="social_media_tasks"
                    activeClassName="active"
                    onClick={(e) => {
                      e.stopPropagation();
                      if (width < 800) {
                        setToggle("-260px");
                      }
                    }}
                  >
                    <div className="items">
                      <i>
                        <MdToken />
                      </i>
                      <h4 className="m-0">Social Media Tasks</h4>
                    </div>
                  </NavLink>
                  <NavLink
                    to="polling_questions"
                    activeClassName="active"
                    onClick={(e) => {
                      e.stopPropagation();
                      if (width < 800) {
                        setToggle("-260px");
                      }
                    }}
                  >
                    <div className="items">
                      <i>
                        <FaPoll />
                      </i>
                      <h4 className="m-0">Polling Questions</h4>
                    </div>
                  </NavLink>
                </div>
              )}
            </div>*/}

            {/* <NavLink
              to="enable_2fa"
              activeClassName="active"
              onClick={() => (width < 800 ? setToggle("-260px") : "")}
            >
              <div className="items">
                <i>
                  <MdKey />
                </i>
                <h4 className="m-0">Two-Factor Authentication</h4>
              </div>
            </NavLink> */}

            {/* <NavLink
              to="support"
              activeClassName="active"
              onClick={() => (width < 800 ? setToggle("-260px") : "")}
            >
              <div className="items">
                <i>
                  <MdOutlineSupportAgent />
                </i>
                <h4 className="m-0">Support</h4>
              </div>
            </NavLink> */}

            {/* <div
              className="dropdownitems"
              onClick={() => handleDropdownToggle("settings")}
            >
              <div className={`head items`}>
                <i>
                  <IoMdSettings />
                </i>
                <h4 className="m-0">Settings</h4>
                <i
                  className="dropicon"
                  style={{
                    transform: `rotate(${
                      openDropdown === "settings" ? "180deg" : "0deg"
                    })`,
                  }}
                >
                  <BsChevronDown />
                </i>
              </div>
              {openDropdown === "settings" && (
                <div className="dropdown">
                  <NavLink
                    to="coin_settings"
                    activeClassName="active"
                    onClick={(e) => {
                      e.stopPropagation();
                      if (width < 800) {
                        setToggle("-260px");
                      }
                    }}
                  >
                    <div className="items">
                      <i>
                        <BsHddStackFill />
                      </i>
                      <h4 className="m-0">Token Rate Setting</h4>
                    </div>
                  </NavLink>
                </div>
              )}
            </div> */}

            <div className="items" onClick={Logout}>
              <i>
                <IoIosLogOut />
              </i>
              <h4 className="m-0">Logout</h4>
            </div>
          </section>
        </div>
        <div
          id="page-content"
          className="p-0"
          style={{
            background: "#F4F7FC",
            minHeight: "100vh",
            marginLeft:
              width > 900 ? (toggle === "-260px" ? "0px" : "260px") : "0px",
          }}
        >
          <div className="navMain">
            <div className="topNavbar">
              <i
                onClick={() =>
                  toggle === "-260px" ? setToggle("0") : setToggle("-260px")
                }
                style={{ cursor: "pointer" }}
              >
                <GiHamburgerMenu />
              </i>

              <ConnectButton screenWidth={width} toggle={toggle} />
            </div>
          </div>

          <div style={{ margin: "80px 5px" }}>{<NavPages />}</div>
        </div>
      </Container>
    </React.Fragment>
  );
};
export default Sidebar;
